export default __webpack_public_path__ + "static/media/fo.54fd5278.svg";